import { Button, IconButton, Switch } from '@material-ui/core';
import CancelIcon from '@material-ui/icons/Cancel';
import { styled } from '@mui/material/styles';
import React, { useState } from 'react';
import './SettingsScreen.scss';
import DisablingPopupModel from '../../../../../../shared/disable-popup/Disable-Popup';
import { updateHotelSystemSetting } from '../../../../../../utils/IntegrationsAPIUtils';
import { useDispatch } from 'react-redux';
import { fetchHotelSystemSettings } from '../../../../configurationSlice';
import { notificationManager } from '../../../../../../utils/NotificationUtils';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../../../../utils/loaderSlice';
import { ENVIRONMENT } from '../../../../../../env/Configurations';

const SettingsScreen = (props) => {
  const { toggleDrawer, currentObj, selectedHotel, showLoader = () => {} } = props;
  const [selectedValue, setSelectedValue] = useState({
    title: '',
    name: '',
    isActive: false,
    value: null,
    index: null,
  });
  const dispatch = useDispatch();

  const [details, setDetails] = useState([
    {
      title: 'Room Reservation',
      isActive: currentObj.roomReservations,
      tag: 'roomReservations',
    },
    {
      title: 'Digital Check-in',
      isActive: currentObj.digitalCheckIn,
      tag: 'digitalCheckIn',
    },
    {
      title: 'Digital Check-out',
      isActive: currentObj.digitalCheckOut,
      tag: 'digitalCheckOut',
    },
    {
      title: 'Table Reservation',
      isActive: currentObj.tableReservation,
      tag: 'tableReservation',
    },
    {
      title: 'Spa Reservation',
      isActive: currentObj.spaReservation,
      tag: 'spaReservation',
    },
    {
      title: 'In-Room Dining',
      isActive: currentObj.inRoomDinning,
      tag: 'inRoomDinning',
    },
    {
      title: 'Housekeeping',
      isActive: currentObj.housekeeping,
      tag: 'housekeeping',
    },
    {
      title: 'Telephony',
      isActive: currentObj.telephony,
      tag: 'telephony',
    },
    { title: 'Loyalty', isActive: currentObj.loyalty, tag: 'loyalty' },
    { title: 'Payment', isActive: currentObj.payment, tag: 'payment' },
    { title: 'Weather', isActive: currentObj.weather, tag: 'weather' },
    { title: 'DocumentScan', isActive: currentObj.documentScan, tag: 'documentScan' },
    { title: 'Travel Service', isActive: currentObj.travelService, tag: 'travelService' },
    { title: 'CHAT', isActive: currentObj.chat, tag: 'chat' },
    {
      title: 'Event Hub',
      isActive: currentObj.eventHub,
      tag: 'eventHub',
    },
    {
      title: 'Analytics',
      isActive: currentObj.analytics,
      tag: 'analytics',
    },
    {
      title: 'Third Party Notification Service',
      isActive: currentObj.thirdPartyNotificationService,
      tag: 'thirdPartyNotificationService',
    },
    // {
    //   title: 'Central Reservation System',
    //   isActive: currentObj.centralReservationSystem,
    //   tag: 'centralReservationSystem',
    // },
  ]);

  const CustomSwitch = styled(Switch)(({ theme }) => ({
    '& .MuiSwitch-switchBase.Mui-checked': {
      color: '#03E67C',
    },
    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
      backgroundColor: '#03E67C',
    },
  }));

  const handleChange = (value, key) => {
    if (value.isActive) {
      setSelectedValue({
        title: 'Are you sure you want to disable',
        name: value.title,
        isActive: true,
        value: value,
        index: key,
      });
    } else {
      const listData = [...details];
      listData[key] = {
        ...value,
        isActive: value.isActive ? false : true,
      };
      setDetails(listData);
    }
  };

  const onCancel = (e) => {
    toggleDrawer(false);
  };

  const handleSubmit = async () => {
    const payload = {
      hotelId: selectedHotel,
      digitalCheckIn: details.find((d) => d.tag === 'digitalCheckIn')?.isActive ?? false,
      digitalCheckOut: details.find((d) => d.tag === 'digitalCheckOut')?.isActive ?? false,
      housekeeping: details.find((d) => d.tag === 'housekeeping')?.isActive ?? false,
      inRoomDinning: details.find((d) => d.tag === 'inRoomDinning')?.isActive ?? false,
      roomReservations: details.find((d) => d.tag === 'roomReservations')?.isActive ?? false,
      spaReservation: details.find((d) => d.tag === 'spaReservation')?.isActive ?? false,
      tableReservation: details.find((d) => d.tag === 'tableReservation')?.isActive ?? false,
      telephony: details.find((d) => d.tag === 'telephony')?.isActive ?? false,
      loyalty: details.find((d) => d.tag === 'loyalty')?.isActive ?? false,
      payment: details.find((d) => d.tag === 'payment')?.isActive ?? false,
      weather: details.find((d) => d.tag === 'weather')?.isActive ?? false,
      documentScan: details.find((d) => d.tag === 'documentScan')?.isActive ?? false,
      travelService: details.find((d) => d.tag === 'travelService')?.isActive ?? false,
      chat: details.find((d) => d.tag === 'chat')?.isActive ?? false,
      eventHub: details.find((d) => d.tag === 'eventHub')?.isActive ?? false,
      analytics: details.find((d) => d.tag === 'analytics')?.isActive ?? false,
      thirdPartyNotificationService:
        details.find((d) => d.tag === 'thirdPartyNotificationService')?.isActive ?? false,
      centralReservationSystem:
        details.find((d) => d.tag === 'centralReservationSystem')?.isActive ?? false,
    };

    try {
      dispatch(stepUpLoaderCount());
      toggleDrawer(false);
      await updateHotelSystemSetting(payload);
      dispatch(fetchHotelSystemSettings(selectedHotel));
      notificationManager('success', 'Hotel System Settings Updated Successfully');
    } catch (error) {
      if (ENVIRONMENT === 'dev') {
        console.log(error?.message);
      }

      notificationManager('danger', 'Hotel System Settings Updated Failed!');
    } finally {
      dispatch(stepDownLoaderCount());
    }
  };

  const handleClose = () => {
    setSelectedValue({
      title: '',
      name: '',
      isActive: false,
      value: null,
      index: null,
    });
  };

  const onDisableModuleCancel = () => {
    handleClose();
  };
  const onDisableModule = (e) => {
    const listData = [...details];
    listData[selectedValue.index] = {
      ...selectedValue.value,
      isActive: selectedValue.value.isActive ? false : true,
    };
    setDetails(listData);
    handleClose();
  };

  return (
    <div className='category-create'>
      <div className='container pt-4 d-flex align-items-end flex-column '>
        <div className='row px-3 w-100 mt-4'>
          <div className='col-md-12'>
            {selectedValue?.isActive && (
              <DisablingPopupModel
                disablePopUp={selectedValue}
                onDisabling={onDisableModule}
                onDisablingCancel={onDisableModuleCancel}
              />
            )}
            <div className='row px-3 w-100 mt-4'>
              <div className='col-md-6'>
                <span className='page-title'>Settings</span>
              </div>
              <div className='col-md-6 d-flex justify-content-end'>
                <IconButton aria-label='delete' onClick={(e) => onCancel(e)}>
                  <CancelIcon />
                </IconButton>
              </div>
            </div>
            <div className='row px-3 w-100 mt-4'>
              <div className='col-md-6'>
                <span className='sub-title'>Modules</span>
              </div>
            </div>
          </div>
        </div>
        <div className='row px-3 w-100 d-flex mt-4 form-scroll'>
          <div className='row'>
            {details?.map((value, key) => {
              return (
                <div className='col-md-12 pb-3' key={key}>
                  <div className='attached-doc d-flex justify-content-between p-3 align-items-center'>
                    <div>
                      <div className='attached-doc-name'>{value?.title}</div>
                    </div>
                    <CustomSwitch
                      checked={value?.isActive}
                      onChange={(e) => {
                        handleChange(value, key);
                      }}
                    />
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        <div className='row mx-2 mt-auto px-4 w-100 pb-5'>
          <div className='col-md-12 d-flex justify-content-start'>
            <Button
              variant='contained'
              color='primary'
              className='me-3'
              size='large'
              onClick={handleSubmit}
            >
              Save
            </Button>
            <Button
              variant='outlined'
              type='button'
              color='secondary'
              size='large'
              onClick={(e) => onCancel(e)}
            >
              Cancel
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SettingsScreen;
